import React, { Component } from 'react'
import { MuiGrid, MuiButton, MuiTextField, MuiTypography, MuiFormControlLabel } from '../../../ui';
import { TimeComponent } from '.';
import { MuiKeyboardArrowUp, MuiKeyboardArrowDown, MuiRadioGroup, MuiInputAdornment } from '../../../ui/MaterialUIComponents';
import { GradePickerComponent, gradePickerUtil } from '../../gradePicker'
import lodashUtil from 'lodash';
import theme from '../../../../assests/theme'
import { Radio } from '../../../ui/customUIComponents'
import { ToggleButtonGroup, ToggleButton } from '../../../ui/customUIComponents/Toggle'
class WeeklyCalendarComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			gradeDetailsInPeriod: this.props.gradeDetailsInPeriod,
			gradeLevelForPeriod: undefined,
			openForPeriods: false,
			/**
			 * we can take only one flag (openForPeriods) since we can manipulte it, 
			 * we can use the same flag for both gradePicker opening and toggling between arrow up and down.
			 * Change in other components
			 */
		}
	}

	handleOpen = () => {
		let calendarGradeDetails = this.props.gradeDetailsInWeeklyCal;
		if (this.props.editPeriod === false) {
			let subSetGradeLevel = gradePickerUtil.showSubsetOfGrades(this.props.gradeLevelsForCalendar, calendarGradeDetails);
			let savedGradeLevel = gradePickerUtil.constructGradeLevelJSON(subSetGradeLevel, this.state.gradeDetailsInPeriod)
			this.setState({
				openForPeriods: true, gradeLevelForPeriod: savedGradeLevel,
			});
		} else {
			let subSetGradeLevel = gradePickerUtil.showSubsetOfGrades(this.props.gradeLevelsForCalendar, calendarGradeDetails);
			let savedGradeLevel = gradePickerUtil.constructGradeLevelJSON(subSetGradeLevel, this.props.gradeDetailsInPeriod)
			this.setState({
				openForPeriods: true, gradeLevelForPeriod: savedGradeLevel,
			});
		}
	};


	handleClose = () => {
		this.setState({
			openForPeriods: false,
		})
	};


	saveForPeriods = (gradeDetails) => {
		this.props.gradePickerSaveInPeriods(gradeDetails)
		this.setState({
			openForPeriods: false,
		})
	}


	render() {
		const { i18n } = this.props
		
		return (
			<MuiGrid container xs={12} style={{ padding: "8px" }} >
				<MuiGrid container style={{ border: "1px solid   " + theme.palette.primary.lighter }}>
					{/* RADIO BUTTON */}
					<MuiGrid container style={{ padding: "8px" }}>
						<MuiRadioGroup value={this.props.radioButtonValue} onChange={this.props.handleChangeForRadioButton} row>
							<MuiFormControlLabel
								value="period"
								control={<Radio size="small" />}
								label="Period"
								labelPlacement="end"
							/>
							<MuiFormControlLabel
								value="lunch"
								control={<Radio size="small" />}
								label="Lunch"
								labelPlacement="end"
							/>
							<MuiFormControlLabel
								value="break"
								control={<Radio size="small" />}
								label="Break"
								labelPlacement="end"
							/>
						</MuiRadioGroup>
					</MuiGrid>

					{/* TIME  */}
					<MuiGrid
						container
						justify="space-evenly"
						alignItems="center"
						style={{
							padding: "8px",
							borderTop: "1px solid   " + theme.palette.primary.lighter
						}}
					>

						{/* Start time */}
						<MuiGrid item xs={3} >
							<TimeComponent
								{...this.props}
								label="Start Time"
								value={this.props.startTime}
								handleTimeChange={this.props.handleTimeChange}
							/>
						</MuiGrid>

						{/* End time */}
						<MuiGrid item xs={3} >
							<TimeComponent
								{...this.props}
								label="End Time"
								value={this.props.endTime}
								handleTimeChange={this.props.handleTimeChange}
							/>
						</MuiGrid>

						{/* Duration */}
						<MuiGrid item xs={4} >
							<MuiGrid container>
								<MuiTextField
									type="number"
									min={1}
									label="Duration in minutes"
									variant="outlined"
									InputLabelProps={{ shrink: true }}
									InputProps={{ endAdornment: <MuiInputAdornment position="end">Min </MuiInputAdornment> }}
									value={this.props.duration}
									defaultValue={this.props.duration}
									onChange={this.props.handleDurationChange}
								/>
							</MuiGrid>

							<MuiGrid container style={{ paddingTop: "8px" }}>
								<MuiTypography variant="caption">
									Note: {this.props.durationNote}
								</MuiTypography>
							</MuiGrid>
						</MuiGrid>

						{/* Duration Note
						<MuiGrid 
						container 
						direction="row-reverse" 
						>
							
						</MuiGrid>*/}
					</MuiGrid>

					{/* GRADE PICKER */}
					{this.props.showGradeDropDownInPeriod === true ?
						<MuiGrid container alignContent="center" style={{ borderTop: "1px solid   " + theme.palette.primary.lighter, padding: "8px" }}>
							<MuiGrid item xs={3} style={{ border: "1px solid   " + theme.palette.primary.lighter }}>
								<MuiGrid container justify="flex-end" alignItems="center" style={{ padding: "8px" }} >
									<MuiGrid item xs >
										{
											this.props.gradeDetailsInPeriod != null || !lodashUtil.isEmpty(this.props.gradeDetailsInPeriod) ?
												<MuiTypography variant="caption">{gradePickerUtil.getGradesString(this.props.gradeDetailsInPeriod)}</MuiTypography>
												:
												<MuiTypography variant="caption">Please select grades</MuiTypography>}
									</MuiGrid>
									<MuiGrid item xs={2} onClick={() => this.props.toggleGradPicker()} style={{ cursor: "pointer" }}>
										{this.state.openForPeriods === true ?

											<MuiGrid item onClick={() => this.handleClose()}>
												<MuiKeyboardArrowUp color="primary" />
											</MuiGrid>
											:
											<MuiGrid item onClick={() => this.handleOpen()}>
												<MuiKeyboardArrowDown color="primary" />
											</MuiGrid>

										}

									</MuiGrid>
								</MuiGrid>
								{this.state.openForPeriods === true &&
									<GradePickerComponent
										{...this.props}
										{...this.state}
										open={this.state.openForPeriods}
										handleClose={this.handleClose}
										handleOpen={this.handleOpen}
										gradeLevels={this.state.gradeLevelForPeriod}
										onClickOfSaveInGradePicker={this.saveForPeriods}
									/>
								}
							</MuiGrid>
						</MuiGrid>
						:
						null
					}

					{/* DAYS selection */}
					<MuiGrid container alignItems="center" justify="flex-start" style={{ borderTop: "1px solid   " + theme.palette.primary.lighter }}>

						<MuiGrid item xs={1} align="center">
							<MuiTypography>Repeat:</MuiTypography>
						</MuiGrid>

						<MuiGrid item xs={6} align="center" >
							<ToggleButtonGroup
								value={this.props.repeatDays}
								spacing={"4px"}
								style={{ paddingTop: "8px", paddingBottom: "8px", width: '100%' }}
								onChange={(event, value) => this.props.onClickOfDays(event, value)}>

								<ToggleButton value="1" style={theme.dayToggleButtonForCalendarStyle} >M</ToggleButton>
								<ToggleButton value="2" style={theme.dayToggleButtonForCalendarStyle}>T</ToggleButton>
								<ToggleButton value="3" style={theme.dayToggleButtonForCalendarStyle}>W</ToggleButton>
								<ToggleButton value="4" style={theme.dayToggleButtonForCalendarStyle}>T</ToggleButton>
								<ToggleButton value="5" style={theme.dayToggleButtonForCalendarStyle}>F</ToggleButton>
								<ToggleButton value="6" style={theme.dayToggleButtonForCalendarStyle}>S</ToggleButton>
								<ToggleButton value="0" style={theme.dayToggleButtonForCalendarStyle}>S</ToggleButton >
							</ToggleButtonGroup>
						</MuiGrid>
					</MuiGrid>
				</MuiGrid>
				{/* SAVING Last row  */}
				<MuiGrid container justify="flex-end" spacing={1} style={{ paddingTop: " 8px " }}>
					{this.props.editPeriod === true &&
						<MuiGrid item>
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={this.props.edit ? () => this.props.weeklyCalendarDelete(this.props.cal) : () => this.props.weeklyCalendarDelete(this.props.calendar)} >{i18n.commonTexts.delete}</MuiButton>
						</MuiGrid>}
					<MuiGrid item>
						<MuiButton style={theme.secondaryButtonStyle} onClick={() => this.props.weeklyCalCancel()} >
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>

					<MuiGrid item>
						<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => this.props.onClickOfSavePeriod(this.props.cal)} >
							{i18n.commonTexts.apply}
						</MuiButton>
					</MuiGrid>

				</MuiGrid>


			</MuiGrid>
		)
	}
}

export default WeeklyCalendarComponent
